// extracted by mini-css-extract-plugin
export var fullscreen = "_redotech-redo-web-src-storefront-merchant-customizable-modal-fullscreen";
export var modalWrapper = "_redotech-redo-web-src-storefront-merchant-customizable-modal-modal-wrapper";